<template>
  <el-dialog
    title="导入坐席"
    :visible.sync="disabled"
    :destroy-on-close="true"
    width="666px"
    :modal="false"
    @close="close"
  >
    <el-form :model="form" ref="ruleForm">
      <div class="download">
        <p>
          1.点击
          <span @click="down">下载模板</span>
        </p>
        <p>2.将要导入的数据填写到模板文件中</p>
        <p>3.模板中表头不可更改，不可删除</p>
        <p>4.默认读取Excel表格的Sheet1的内容</p>
        <p>5.<span>确认表格中的手机号已经导入到企业,否则将无法增加</span></p>
        <p>6.<span>同一个ICCID只能导入一个企业</span></p>
      </div>
      <el-upload
        class="upload-demo"
        action="#"
        multiple
        :limit="1"
        drag
        :file-list="fileList"
        :on-change="fileChange"
        :on-remove="changeRemove"
        :auto-upload="false"
        :on-exceed="handleExceed"
      >
        <el-button size="small" type="primary" slot="trigger">
          <i class="el-icon-download"></i> 点击上传文件
        </el-button>
      </el-upload>
      <div style="display: flex; justify-content: flex-end; margin: 14px 0">
        <el-button size="small" type="primary" @click="onSubmitUpload">
          确定
        </el-button>
        <el-button size="small" @click="close"> 取消 </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { getData } from "@/api/index";
import axios from "axios";
export default {
  props: {
    isShow: Boolean,
    company_id: Number,
  },
  data() {
    return {
      form: { file: "" },
      fileList: [],
      disabled: this.isShow,
      uploadUserUrl: `${localStorage.getItem(
        "service_cname"
      )}agent/company.CompanyUserController/ImportFileUserAction`,
    };
  },
  methods: {
    down() {
      this.$message.success("正在下载中");
      getData("company.CompanyUserController/demo2Action").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        window.location.href = res.data;
      });
    },
    fileChange(file) {
      this.form.file = file.raw;
    },
    changeRemove() {
      this.form.file = "";
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    async onSubmitUpload() {
      if (this.form.file) {
        const formData = new FormData();
        formData.append("file", this.form.file);
        formData.append("company_id", this.company_id);
        const res = await axios.post(this.uploadUserUrl, formData, {
          headers: {
            token: sessionStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        });
        if (res.data.code !== 200) return this.$message.error(res.data.message);
        this.$message.success("坐席导入成功");
        this.close();
        this.$parent.esarchang();
      } else {
        return this.$message.error("请选择要导入的文件");
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="less" scoped>
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
.avatar-uploader {
  display: none;
}
.content {
  height: 300px;
  overflow: hidden;
  /deep/img {
    width: 360px;
  }
}
.content:hover {
  overflow-y: overlay;
}
</style>
<style src="@/assets/css/index.css" scoped></style>
<style lang="less" src="@/assets/css/comparison.less" scoped></style>
